import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig } from '../../config/config'; // Importing development configuration
import { persons } from '../../models/persons'; // Importing persons model

/**
 * MyInformationView class extends JetView to create a user information view.
 */
export default class MyInformationView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration
        const theme = this.app.config.theme; // Theme configuration
        const lenguages = [
            // Language options for the user
            { id: 'ES', value: 'español (o castellano) (ES)' },
            { id: 'EN', value: 'English (EN)' },
        ];
        const main1 = {
            // Main information section configuration
            margin: 5,
            minWidth: 265,
            cols: [
                {
                    padding: 5,
                    rows: [
                        {
                            view: 'text', // Text input for user ID
                            name: 'Id',
                            label: _('Número de usuario'), // User number label
                            labelPosition: 'top',
                            placeholder: _('Número de usuario'), // Placeholder for user number
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for login
                            name: 'Login',
                            label: _('Login para acceso'), // Login label
                            labelPosition: 'top',
                            placeholder: _('Login para acceso'), // Placeholder for login
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for affiliate credits
                            name: 'AffiliateCredits',
                            label: _('Saldo de comisión'), // Commission balance label
                            labelPosition: 'top',
                            placeholder: _('Saldo de comisión'), // Placeholder for commission balance
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for last IP address
                            name: 'LastIPaddress',
                            label: _('Última dirección IP'), // Last IP address label
                            labelPosition: 'top',
                            placeholder: _('Última dirección IP'), // Placeholder for last IP address
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for last modified user
                            name: 'LastModifiedUser',
                            label: _('Último usuario modif'), // Last modified user label
                            labelPosition: 'top',
                            placeholder: _('Último usuario modif'), // Placeholder for last modified user
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'richselect', // Rich select for user type
                            name: 'Type',
                            label: _('Tipo'), // Type label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for selection
                            options: [
                                { id: '0', value: _('Agente') }, // Agent option
                                { id: '1', value: _('Afiliado') }, // Affiliate option
                            ],
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'richselect', // Rich select for user state
                            name: 'State',
                            localId: 'State:combo',
                            label: _('Estado'), // State label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for selection
                            options: [
                                { id: 'A', value: _('Activo') }, // Active option
                                { id: 'I', value: _('Inactivo') }, // Inactive option
                                { id: 'R', value: _('Retirado') }, // Retired option
                            ],
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'richselect', // Rich select for preferred language
                            name: 'PreferredLanguage',
                            localId: 'PreferredLanguage:combo',
                            label: _('Idioma preferido:'), // Preferred language label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for selection
                            options: lenguages, // Language options
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for user name
                            name: 'Name',
                            label: _('Nombre del usuario'), // User name label
                            labelPosition: 'top',
                            placeholder: _('Nombre del usuario'), // Placeholder for user name
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'richselect', // Rich select for country
                            name: 'CountryId',
                            id: 'country',
                            localId: 'Country:combo',
                            label: _('País'), // Country label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for selection
                            options: [], // Country options (to be populated)
                            required: true, // Field is required
                            invalidMessage: 'Campo Requerido', // Error message for required field
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'richselect', // Rich select for currency
                            name: 'CurrencyId',
                            id: 'currency',
                            localId: 'Currency:combo',
                            label: _('Moneda'), // Currency label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for selection
                            options: [], // Currency options (to be populated)
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for creation date
                            name: 'CreatedLocalDate',
                            label: _('Fecha de creación'), // Creation date label
                            labelPosition: 'top',
                            placeholder: _('Fecha de creación'), // Placeholder for creation date
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for last login date
                            name: 'LastLoginLocalDate',
                            label: _('Fecha última entrada'), // Last login date label
                            labelPosition: 'top',
                            placeholder: _('Fecha última entrada'), // Placeholder for last login date
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for last modified date
                            name: 'LastDateModified',
                            label: _('Última Fecha modif'), // Last modified date label
                            labelPosition: 'top',
                            placeholder: _('Última Fecha modif'), // Placeholder for last modified date
                            disabled: true, // Input is disabled
                        },
                    ],
                },
            ],
        };
        const options_main = {
            // Options main section configuration
            margin: 5,
            minWidth: 265,
            cols: [
                {
                    padding: 5,
                    rows: [
                        {
                            view: 'richselect', // Rich select for special status
                            name: 'SpecialStatus',
                            localId: 'SpecialStatus:combo',
                            label: _('Estado especial'), // Special status label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for selection
                            options: [
                                { id: 'A', value: _('Activo') }, // Active option
                                { id: 'I', value: _('Inactivo') }, // Inactive option
                            ],
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'richselect', // Rich select for pin agent
                            name: 'Pinagent',
                            localId: 'Pinagent:combo',
                            label: _('Pinagent'), // Pin agent label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for selection
                            options: [
                                { id: 'S', value: _('Sí') }, // Yes option
                                { id: 'N', value: _('No') }, // No option
                            ],
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'richselect', // Rich select for locked sales
                            name: 'Lockedsales',
                            localId: 'Lockedsales:combo',
                            label: _('Bloqueado para ventas'), // Locked for sales label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for selection
                            options: [
                                { id: 'S', value: _('Sí') }, // Yes option
                                { id: 'N', value: _('No') }, // No option
                            ],
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'richselect', // Rich select for print receipt box
                            name: 'PrintReceiptBox',
                            localId: 'PrintReceiptBox:combo',
                            label: _('Imprime recibo caja'), // Print receipt box label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for selection
                            options: [
                                { id: 'S', value: _('Sí') }, // Yes option
                                { id: 'N', value: _('No') }, // No option
                            ],
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'richselect', // Rich select for allows recharges
                            name: 'AllowsRecharges',
                            localId: 'AllowsRecharges:combo',
                            label: _('Permite recargas'), // Allows recharges label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for selection
                            options: [
                                { id: 'S', value: _('Sí') }, // Yes option
                                { id: 'N', value: _('No') }, // No option
                            ],
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'richselect', // Rich select for activate registration
                            name: 'ActivateRegistration',
                            localId: 'ActivateRegistration:combo',
                            label: _('Permite activar reg'), // Activate registration label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for selection
                            options: [
                                { id: 'S', value: _('Sí') }, // Yes option
                                { id: 'N', value: _('No') }, // No option
                            ],
                            disabled: true, // Input is disabled
                        },
                    ],
                },
            ],
        };
        const betshop_details = {
            // Betshop details section configuration
            margin: 5,
            minWidth: 250,
            cols: [
                {
                    padding: 5,
                    rows: [
                        {
                            view: 'text', // Text input for contact name
                            name: 'ContactName',
                            label: _('Nombre del contacto'), // Contact name label
                            labelPosition: 'top',
                            placeholder: _('Nombre del contacto'), // Placeholder for contact name
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for email
                            name: 'Email',
                            label: _('Correo electrónico'), // Email label
                            labelPosition: 'top',
                            placeholder: _('Correo electrónico'), // Placeholder for email
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for description
                            name: 'Description',
                            label: _('Descripción'), // Description label
                            labelPosition: 'top',
                            placeholder: _('Descripción'), // Placeholder for description
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for phone
                            name: 'Phone',
                            label: _('Teléfono'), // Phone label
                            labelPosition: 'top',
                            placeholder: _('Teléfono'), // Placeholder for phone
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'richselect', // Rich select for concessionaire
                            name: 'Concessionaire',
                            id: 'Concessionaire',
                            localId: 'Concessionaire:combo',
                            label: _('Concesionario'), // Concessionaire label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for selection
                            options: [], // Concessionaire options (to be populated)
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'richselect', // Rich select for subconcessionaire
                            name: 'Subconcessionaire',
                            id: 'Subconcessionaire',
                            localId: 'Subconcessionaire:combo',
                            label: _('Subconcesionario'), // Subconcessionaire label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for selection
                            options: [], // Subconcessionaire options (to be populated)
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'richselect', // Rich select for region
                            name: 'RegionId',
                            id: 'ProvinceRegion',
                            localId: 'ProvinceRegion:combo',
                            label: _('Provincia/Región'), // Region label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for selection
                            options: [], // Region options (to be populated)
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'richselect', // Rich select for city
                            name: 'CityId',
                            id: 'City',
                            localId: 'City:combo',
                            label: _('Ciudad'), // City label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for selection
                            options: [], // City options (to be populated)
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for address
                            name: 'Address',
                            label: _('Dirección'), // Address label
                            labelPosition: 'top',
                            placeholder: _('Dirección'), // Placeholder for address
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for district
                            name: 'District',
                            label: _('Barrio'), // District label
                            labelPosition: 'top',
                            placeholder: _('Barrio'), // Placeholder for district
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for IP
                            name: 'IP',
                            label: _('IP'), // IP label
                            labelPosition: 'top',
                            placeholder: _('IP'), // Placeholder for IP
                            disabled: true, // Input is disabled
                        },
                    ],
                },
            ],
        };
        const center_right = {
            // Center right section configuration
            margin: 5,
            padding: 5,
            cols: [
                {
                    rows: [
                        {
                            view: 'text', // Text input for daily quota reloads
                            name: 'DailyQuotaReloads',
                            label: _('Limite diario de recargas'), // Daily reload limit label
                            labelPosition: 'top',
                            placeholder: _('Limite diario de recargas'), // Placeholder for daily reload limit
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for commission reloads
                            name: 'CommissionReloads',
                            label: _('Comisión recargas'), // Commission reloads label
                            labelPosition: 'top',
                            placeholder: _('Comisión recargas'), // Placeholder for commission reloads
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for minimum bet
                            name: 'MinimumBet',
                            label: _('Apuesta mínima'), // Minimum bet label
                            labelPosition: 'top',
                            placeholder: _('Apuesta mínima'), // Placeholder for minimum bet
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for daily limit
                            name: 'DailyLimit',
                            label: _('Límite diario'), // Daily limit label
                            labelPosition: 'top',
                            placeholder: _('Límite diario'), // Placeholder for daily limit
                            disabled: true, // Input is disabled
                        },
                    ],
                },
            ],
        };
        const right = {
            // Right section configuration
            margin: 5,
            rows: [],
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        const upper_section = {
            // Upper section configuration
            id: 'b5',
            rows: [
                {
                    collapsed: true,
                    multi: true,
                    view: 'accordion', // Accordion view for sections
                    css: 'betShop',
                    margin: 15,
                    responsive: 'b5',
                    id: 'b6',
                    cols: [
                        {
                            multi: true,
                            view: 'accordion', // Accordion for main data
                            css: 'betShop',
                            collapsed: false,
                            paddingY: 10,
                            type: 'clean',
                            rows: [
                                {
                                    header: _('Datos Principales'), // Main data header
                                    body: {
                                        padding: 10,
                                        rows: [
                                            {
                                                margin: 10,
                                                cols: [main1], // Main information section
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                        {
                            multi: true,
                            view: 'accordion', // Accordion for agent data
                            css: 'betShop',
                            collapsed: false,
                            paddingY: 10,
                            type: 'clean',
                            rows: [
                                {
                                    header: _('Datos Agente'), // Agent data header
                                    body: {
                                        rows: [betshop_details], // Betshop details section
                                    },
                                },
                            ],
                        },
                        {
                            multi: true,
                            view: 'accordion', // Accordion for configuration data
                            css: 'betShop',
                            collapsed: false,
                            paddingY: 10,
                            type: 'clean',
                            rows: [
                                {
                                    header: _('Datos Configuracion'), // Configuration data header
                                    body: {
                                        padding: 10,
                                        rows: [
                                            {
                                                margin: 10,
                                                cols: [options_main], // Options main section
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
        };
        const buttons = {
            // Button configuration
            css: 'betShop',
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'), // Clear label
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clear the form
                    },
                },
                {
                    view: 'button', // Save button
                    value: _('Guardar'), // Save label
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        if (this.getRoot().validate()) {
                            // Validate form
                            const newdata = this.getRoot().getValues(); // Get form values
                            this.app.callEvent('customer:save', [newdata]); // Trigger save event
                            this.show('betShop'); // Show bet shop view
                        } else {
                            webix.message({
                                // Show error message if validation fails
                                title: '¡Error!',
                                type: 'alert-error',
                                text: _('Completa los campos...'), // Incomplete fields message
                            });
                        }
                    },
                },
            ],
        };
        return {
            // Return the main form configuration
            view: 'form',
            id: 'formId',
            scroll: 'y',
            rows: [
                {
                    view: 'toolbar', // Toolbar for the form
                    css: theme,
                    elements: [
                        { view: 'label', label: _('Mi Información') }, // Label for the form
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            cols: [
                                {
                                    view: 'icon', // Close icon
                                    icon: 'wxi-close',
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => this.show('/top/dashboard'), // Close action
                                },
                            ],
                        },
                    ],
                },
                upper_section, // Upper section of the form
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} form - The form instance.
     */
    init(form) {
        var vthis = this; // Reference to the current instance
        const _ = this.app.getService('locale')._; // Localization service
        this.on(this.app, 'form:update', (id) => {
            // Event listener for form update
            webix.ajax().get(devConfig.geturlApi() + 'Client/GetClientSpMyInfo', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error message on AJAX failure
                },
                success: function (text, data, XmlHttpRequest) {
                    text = JSON.parse(text); // Parse the response
                    if (text[0].Commission.length > 0) {
                        // Check if commissions exist
                        var commissionsArray = []; // Array to hold commission inputs
                        text[0].Commission.forEach((commision) => {
                            commissionsArray.push({
                                view: 'text', // Text input for commission
                                type: 'number',
                                label: _(commision.Name), // Commission name label
                                labelPosition: 'top',
                                value: commision.Value, // Commission value
                                disabled: true, // Input is disabled
                            });
                        });
                        $$('b6').addView({
                            // Add commissions section to the accordion
                            multi: true,
                            view: 'accordion',
                            css: 'betShop',
                            collapsed: false,
                            paddingY: 10,
                            type: 'clean',
                            rows: [
                                {
                                    header: _('Comisiones'), // Commissions header
                                    body: {
                                        padding: 10,
                                        rows: [
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        margin: 5,
                                                        minWidth: 265,
                                                        cols: [
                                                            {
                                                                padding: 5,
                                                                rows: commissionsArray, // Commission inputs
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                },
                            ],
                        });
                    }
                    vthis.app.callEvent('agent:updatedata', [text[0]]); // Trigger agent update event
                    $$('country').setValue(text[0].CountryId); // Set country value
                    webix.delay(
                        // Delay to set currency and region values
                        function () {
                            $$('currency').setValue(text[0].CurrencyId); // Set currency value
                            $$('ProvinceRegion').setValue(text[0].RegionId); // Set region value
                            webix.delay(
                                function () {
                                    $$('City').setValue(text[0].CityId); // Set city value
                                },
                                '',
                                '',
                                1000,
                            );
                        },
                        '',
                        '',
                        1000,
                    );
                },
            });
        });
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type for AJAX requests
            })
            .post(devConfig.geturlApi() + 'Agent/GetAgentCountries', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error message on AJAX failure
                },
                success: function (text, data, XmlHttpRequest) {
                    var data = JSON.parse(
                        text
                            .replace(/"Id"/g, '"id"') // Normalize JSON keys
                            .replace(/"Name"/g, '"value"'),
                    );
                    var optionsCountries = $$('country').getList(); // Get country list
                    optionsCountries.clearAll(); // Clear existing options
                    optionsCountries.parse(data.Data); // Parse new country options
                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json', // Set content type for AJAX requests
                        })
                        .post(devConfig.geturlApi() + 'Agent/GetAgentsTwoLevels2', '', {
                            error: function (text, data, XmlHttpRequest) {
                                webix.message(_('Error! ')); // Error message on AJAX failure
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var data = JSON.parse(
                                    text
                                        .replace(/"Id"/g, '"id"') // Normalize JSON keys
                                        .replace(/"Name"/g, '"value"'),
                                );
                                if (data.Data.Children == null) {
                                    // Check if there are no children
                                    $$('Concessionaire').hide(); // Hide concessionaire field
                                    $$('Subconcessionaire').hide(); // Hide subconcessionaire field
                                } else {
                                    var options = $$('Concessionaire').getList(); // Get concessionaire list
                                    options.clearAll(); // Clear existing options
                                    options.parse(data.Data.Children); // Parse new options
                                }
                                vthis.app.callEvent('form:update', [
                                    vthis.getParam('user', true), // Trigger form update event
                                ]);
                            },
                        });
                },
            });
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type for AJAX requests
            })
            .post(devConfig.geturlApi() + 'Agent/GetAgentsTwoLevels?isList=1', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error message on AJAX failure
                },
                success: function (text, data, XmlHttpRequest) {
                    var data = JSON.parse(
                        text
                            .replace(/"UserName"/g, '"id"') // Normalize JSON keys
                            .replace(/"Name"/g, '"value"'),
                    );
                    var options = $$('Concessionaire').getList(); // Get concessionaire list
                    options.clearAll(); // Clear existing options
                    options.parse(data.Data.Children); // Parse new options
                },
            });
        this.on(
            this.app,
            'agent:updatedata',
            (
                person, // Event listener for agent data update
            ) => form.setValues(person), // Set form values with updated person data
        );
        this.on(
            this.app,
            'person:select',
            (
                person, // Event listener for person selection
            ) => form.setValues(person), // Set form values with selected person data
        );
        $$('country').attachEvent('onChange', function (newv, oldv) {
            // Change event for country selection
            var optionscountries = this.getList().getItem(newv); // Get selected country
            if (optionscountries != undefined) {
                var optionscurrencies = $$('currency').getList(); // Get currency list
                optionscurrencies.clearAll(); // Clear existing options
                optionscurrencies.parse(optionscountries.currencies); // Parse new currency options
                var optionsProvinceRegions = $$('ProvinceRegion').getList(); // Get province/region list
                optionsProvinceRegions.clearAll(); // Clear existing options
                optionsProvinceRegions.parse(optionscountries.departments); // Parse new province/region options
            }
        });
        $$('ProvinceRegion').attachEvent('onChange', function (newv, oldv) {
            // Change event for province/region selection
            var optionsProvinceRegions = this.getList().getItem(newv); // Get selected province/region
            var optionsCity = $$('City').getList(); // Get city list
            optionsCity.clearAll(); // Clear existing options
            if (optionsProvinceRegions != undefined) {
                optionsCity.parse(optionsProvinceRegions.cities); // Parse new city options
            }
        });
        $$('Concessionaire').attachEvent('onChange', function (newv, oldv) {
            // Change event for concessionaire selection
            var optionsProvinceRegions = this.getList().getItem(newv); // Get selected concessionaire
            var optionsCity = $$('Subconcessionaire').getList(); // Get subconcessionaire list
            optionsCity.clearAll(); // Clear existing options
            if (optionsProvinceRegions != undefined) {
                optionsCity.parse(optionsProvinceRegions.Children); // Parse new subconcessionaire options
            }
        });
    }

    /**
     * Retrieves localized options for combo boxes.
     */
    getLocalizedComboOptions() {
        const _ = this.app.getService('locale')._; // Localization service
        let p_options = webix.copy(getPositions()); // Get positions options
        p_options.map((x) => (x.value = _(x.value))); // Localize position values
        this.$$('position:combo').getPopup().getList().parse(p_options); // Update position combo
        let t_options = webix.copy(getTags()); // Get tags options
        t_options.map((x) => (x.value = _(x.value))); // Localize tag values
        this.$$('tags:combo').getPopup().getList().parse(t_options); // Update tags combo
        let c_options = webix.copy(getCities()); // Get cities options
        c_options.map((x) => (x.value = _(x.value))); // Localize city values
        this.$$('cities:combo').getPopup().getList().parse(c_options); // Update cities combo
    }
}

// FILE DOCUMENTED
